import React, { Fragment } from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import DeleteIcon from '../Icons/DeleteIcon'
import CaseDetailModalRefactor from './CaseDetailModalRefactor'

const CaseDetailModal = (props) => {
  if (props.refactor) {
    return <CaseDetailModalRefactor {...props} />
  }

  return(
    <div>
      {props.altHeader ?
        <Fragment>
          {props.altHeader} 
        </Fragment> :
        <Modal.Header style={
          props.alt ? {backgroundColor:'#00e5ff'} : {backgroundColor:'#242323'}
        }>
          <h4 style={
            props.alt ?  {color:'#1C1B1B'} : {color:'#F5F5FC'}
          }>{props.title} {props.id}</h4>
        </Modal.Header>
      }
      
      <Modal.Body style={
        props.alt ?
        {
          backgroundColor:'#242323',
          color:'#F5F5FC',
          fontSize:'1.0em',
          fontWeight:'400',
        } :
        {
          backgroundColor:'#1C1B1B',
          color:'#F5F5FC',
          fontSize:'1.0em',
          fontWeight:'400',
        }

      }>
        {props.children}
        <Modal.Footer style={props.alt ? {backgroundColor:'#242323'} : {backgroundColor:'#1C1B1B'}}>
          <Button style={{alignItems: 'center', backgroundColor: '#321717', border: '1px solid #8E2C2C', borderRadius: '.55em', color: '#F5F5FC', display: 'inline-flex', gap: '.4em', minHeight: '3em'}} onClick={() => props.closeFunction()}>
            <DeleteIcon fill='Red' height='1.15em' width='1.15em' /> Close
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </div>
  )
}

export default CaseDetailModal
